// removed by extract-text-webpack-plugin
module.exports = {"component":"JdMlekkLuPYpIQeU9Bbh5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Health/GetLatestRecord/GetLatestRecord.css
// module id = 1248
// module chunks = 0